import React from 'react';
import '../style/Footer.css';
import { FaMapMarkerAlt } from "react-icons/fa";
import { IoCall,IoMail  } from "react-icons/io5";
import { TbClockHour4Filled } from "react-icons/tb";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Colonne 1 - Logo & infos */}
          <div className="footer-col">
            <div className="footer-logo">
              <span className="logo-beverly">BEVERLY HILLS</span>
              <span className="logo-construction">CONSTRUCTION</span>
            </div>
            <p className="footer-description">
              Location d'engins de travaux publics, construction et travaux publics au Cameroun.
            </p>
            <p className="footer-address">
              <FaMapMarkerAlt /> Denver, Douala – Cameroun
            </p>
          </div>

          {/* Colonne 2 - Liens utiles */}
          <div className="footer-col">
            <h3>Liens rapides</h3>
            <ul>
              <li><a href="#accueil">Accueil</a></li>
              <li><a href="#a-propos">À propos</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#engins">Nos engins</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          {/* Colonne 3 - Contact */}
          <div className="footer-col">
            <h3>Contact</h3>
            <ul className="footer-contact">
              <li><IoCall /> +237 6 51 61 24 51 | 6 50 08 07 21</li>
              <li><IoMail  />contact@beverlyhillsconstruction.com</li>
              <li><TbClockHour4Filled /> Lundi-Vendredi: 8h-17h</li>
              <p>Samedi: 8h-14h</p>
            </ul>
          </div>

          {/* Colonne 4 - Horaires / rapide */}
          <div className="footer-col">
            <h3>Intervention</h3>
            <p>Sur tout le Cameroun</p>
            <p>Devis gratuit sur rendez-vous</p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Beverly Hills Construction – Tous droits réservés</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;